import { useEffect } from "react";
import { connect } from "react-redux";
import { UserIcon } from "../../components/Icon";
import { CommonHeader, ErrorSuccessModal } from "../../components/commons";
import SkeltonElement from "../../components/commons/SkeltonLoader/SkeltonElement";
import { resetSession } from "../../redux/auth";
import {
  resetInsightAdvancedError,
  resetInsightAdvancedSuccess,
  resetProfiltLossData,
  resetTotalExpenses,
  resetTotelSales,
} from "../../redux/insightsAdvanced";
import { RootState } from "../../redux/rootReducers";
import InsightsBalanceSheetPieChart from "./InsightsBalanceSheetPieChart";
import ProfitLoss from "./ProfitLoss";
import TotalExpense from "./TotalExpense";
import TotalSales from "./TotalSales";

type AppProps = {
  history: any;
  token: string | null;
  fetching: boolean;
  statusCode: number | null;
  error: string | null;
  success: number | null;
  dispatchResetProfiltLossData: () => void;
  TotalExpenseFetching: boolean;
  dispatchResetInsightAdvancedError: () => void;
  dispatchResetInsightAdvancedSuccess: () => void;
  dispatchResetSession: () => void;
  dispatchResetTotalExpenses: () => void;
  dispatchResetTotelSales: () => void;
};

const InsightSummary = ({
  history,
  token,
  dispatchResetProfiltLossData,
  TotalExpenseFetching,
  fetching,
  dispatchResetSession,
  statusCode,
  error,
  success,
  dispatchResetInsightAdvancedError,
  dispatchResetInsightAdvancedSuccess,
  dispatchResetTotalExpenses,
  dispatchResetTotelSales,
}: AppProps) => {
  const company_name =
    history &&
    history.location &&
    history.location.state &&
    history.location.state.company_name
      ? history.location.state.company_name
      : "";

  const client_code =
    history &&
    history.location &&
    history.location.state &&
    history.location.state.client_code
      ? history.location.state.client_code
      : null;

  useEffect(() => {
    dispatchResetInsightAdvancedError();
    dispatchResetProfiltLossData();
    dispatchResetInsightAdvancedSuccess();
    dispatchResetTotalExpenses();
    dispatchResetTotelSales();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetInsightAdvancedError();
              dispatchResetInsightAdvancedSuccess();
            }}
          />
        );
      }
    }

    return false;
  };

  return (
    <>
      <div className="row">
        <div className="col-md-6 mb-3">
          <CommonHeader title="Insight Summary" />
          <div className="d-flex align-items-center ml-2">
            {client_code ? (
              <>
                <UserIcon /> &nbsp;
                {company_name} {"(" + client_code + ")"}
              </>
            ) : null}
          </div>
        </div>
        <div className="col-md-12">
          <div className="new-table-card p-4">
            {TotalExpenseFetching ? (
              <SkeltonElement type="XXLavatar" />
            ) : (
              <ProfitLoss
                history={history}
                client_code={client_code}
                company_name={company_name}
              />
            )}

            <div className="mt-4">
              {" "}
              <InsightsBalanceSheetPieChart history={history} />
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "49% 49%",
                gap: "2%",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <TotalSales
                history={history}
                client_code={client_code}
                company_name={company_name}
              />
              <TotalExpense
                history={history}
                client_code={client_code}
                company_name={company_name}
              />
            </div>
          </div>
        </div>
      </div>
      {handleErrorModal()}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.insightsAdvanced.fetching,
  error: state.insightsAdvanced.error,
  statusCode: state.insightsAdvanced.statusCode,
  success: state.insightsAdvanced.success,
  TotalExpenseFetching: state.insightsAdvanced.totalExpenseFetching,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetProfiltLossData: () => dispatch(resetProfiltLossData()),
  dispatchResetInsightAdvancedError: () =>
    dispatch(resetInsightAdvancedError()),
  dispatchResetInsightAdvancedSuccess: () =>
    dispatch(resetInsightAdvancedSuccess()),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetTotalExpenses: () => dispatch(resetTotalExpenses()),
  dispatchResetTotelSales: () => dispatch(resetTotelSales()),
});
export default connect(mapStateToProps, mapDispatchToProps)(InsightSummary);
